import './assets/styles/main.scss';
import OnBoardingRoutes from './routes/OnboardingRoutes';

export default OnBoardingRoutes;
